<template>
  <!-- Tags -->
  <ul class="project-tag-list">
    <li v-for="tag in props.tags" :key="tag.id">
      <button
        class="button-round-1"
        @click="
          router.push(
            localePath({
              name: 'projects',
              query: { [`${props.query}`]: tag.slug },
            })
          )
        "
      >
        <span>{{ tag.title }}</span>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesProjectTagList',
}
</script>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps({
  tags: Array,
  query: String,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
